import React from 'react'
import clsx from 'clsx'
import TopBanner from './topBanner/TopBanner'
import { MenuItems } from '../../../enums/MenuItems'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'
import { Toaster } from 'sonner'
import { twMerge } from 'tailwind-merge'

type Props = {
    activeMenuItem: MenuItems
    className?: string
}

export default function LayoutSingleView({
    children,
    activeMenuItem,
    className,
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    return (
        <div className="h-screen flex flex-col">
            <TopBanner activeMenuItem={activeMenuItem} />
            {/* Main Content Area */}
            <div
                className={twMerge(
                    clsx(
                        'max-w-[1040px] w-full pt-[4px] pb-[64px] mx-auto',
                        className,
                    ),
                )}
            >
                {children}
            </div>
            {/* Global toaster for uiV2 pages */}
            <Toaster richColors />
        </div>
    )
}
